import type React from 'react';
import { PATH } from '~/pages/vendors/deals/[id]/deal_estimation_headers/[headerId]/index';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { EstimationHistoryNavigation } from '~/components/common/constructions/navigation/EstimationHistoryNavigation';
import { useDealEstimationHeaders } from '~/hooks/vendors/deals/useDealEstimationHeaders';
import { ConstructionVendorNavigation } from '~/components/common/constructions/navigation/ConstructionVendorNavigation';
import type { Deal } from '~/models/Deal';
import { ESTIMATION_BY } from '~/models/Deal';
import { IN_ESTIMATION, SEND_ESTIMATE } from '~/models/Status';

type Props = {
  deal: Deal;
};

export const EstimationVendorPanel: React.FC<Props> = ({ deal }: Props) => {
  const id = useIdQueryHandler();
  const { data: dealEstimationHeaders } = useDealEstimationHeaders().index(id);
  if (id === null || dealEstimationHeaders === null) {
    return null;
  }

  const showEstimationNavigation =
    (deal.estimationBy === ESTIMATION_BY.VENDOR &&
      deal.status >= IN_ESTIMATION) ||
    (deal.estimationBy === ESTIMATION_BY.COMPANY &&
      deal.status >= SEND_ESTIMATE);
  if (!showEstimationNavigation) return null;

  return (
    <div>
      <ConstructionVendorNavigation title="工事見積書" />
      <EstimationHistoryNavigation
        dealEstimationHeaders={dealEstimationHeaders}
        detailPagePath={(headerId: number): string => PATH(id, headerId)}
      />
    </div>
  );
};
